import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateThematicArea } from "common/services/data-types.service";
import Form from "./Form";
import { toast } from "react-toastify";

const UpdateThematicArea: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, fetchData, selectedRecord }) => {
  const [loading, setLoading] = useState<boolean>(false);
  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      name: selectedRecord?.name,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter name"),
    }),
    onSubmit: async (values: any) => {
      const data = {
        data: {
          name: values["name"] ? values["name"].trim() : null,
        },
      };

      setLoading(true);
      try {
        await updateThematicArea(selectedRecord.id, data);
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("Thematic area updated successfully", {});
      } catch (e: any) {
        toast.error("Thematic area update failed", {});
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Thematic Area
      </ModalHeader>

      <Form
        validation={validation}
        isUpdate
        loading={loading}
        toggle={toggle}
      />
    </Modal>
  );
};

export default UpdateThematicArea;
